// @flow

import React from 'react';
import type { Node } from 'react';
import StyledWrapper from './wrapper.styled';
import type { ReviewTemplate } from '../../types';

type Props = {
  variant: ?string,
  template: ReviewTemplate,
  children: Node,
};

const Wrapper = ({ variant, template, children }: Props) => (
  <StyledWrapper
    variant={variant}
    template={template}
  >
    {children}
  </StyledWrapper>
);

export default Wrapper;
